import { render, staticRenderFns } from "./CannotDownload.vue?vue&type=template&id=1423000e&"
import script from "./CannotDownload.vue?vue&type=script&lang=js&"
export * from "./CannotDownload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports